import { Button } from 'common-front/src/designSystem/components/button';
import { Dropdown } from 'common-front/src/designSystem/components/dropdown/dropdown';
import { Menu } from 'common-front/src/designSystem/components/dropdown/menu';
import { Trigger } from 'common-front/src/designSystem/components/dropdown/trigger';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { CustomFieldId, FormCustomFieldFragment } from 'common/src/generated/types';
import * as React from 'react';
import { AddFieldsMenu } from '../../forms/update/elements/addFieldsMenu';

interface IAttachFormCustomFieldsAddButtonProps {
    formCustomFields: FormCustomFieldFragment[];
    selectedCustomFieldsIds: Set<CustomFieldId>;

    toggle(field: FormCustomFieldFragment): void;
}

export const AttachFormCustomFieldsAddButton = (props: IAttachFormCustomFieldsAddButtonProps) => {
    const { translate } = useHeavent();

    return (
        <Dropdown>
            <Trigger>
                <Button color="invisible" leftIcon="plus">
                    {translate('lier_un_champ_p_01331')}
                </Button>
            </Trigger>

            <Menu css={{ padding: '0' }} placement="top-start" width={400}>
                <AddFieldsMenu
                    customFields={props.formCustomFields}
                    selectedCustomFieldsIds={props.selectedCustomFieldsIds}
                    toggle={props.toggle}
                />
            </Menu>
        </Dropdown>
    );
};
